import React from "react";
import { connect } from "react-redux";
import type { RootState } from "typesafe-actions";
import { ErrorType } from "@/enums/ErrorType.enum";
import CreditLimitReachedDialog from "./errorDialogs/CreditLimitReachedDialog";
import ErrorDialog from "./errorDialogs/ErrorDialog";
import OrgBlockedCreateDialog from "./errorDialogs/OrgBlockedCreateDialog";

const mapStateToProps = (state: RootState) => ({
  errorType: state.context.error.errorType,
});

type ErrorDialogRouterProps = ReturnType<typeof mapStateToProps>;

export const ErrorDialogRouter: React.FC<ErrorDialogRouterProps> = ({
  errorType,
}) => {
  switch (errorType) {
    case ErrorType.CreateBlockedByOrgPolicy:
      return <OrgBlockedCreateDialog />;
    case ErrorType.CreateBlockedByCreditLimit:
      return <CreditLimitReachedDialog />;
    default:
      return <ErrorDialog />;
  }
};

export default connect(mapStateToProps)(ErrorDialogRouter);
